export default __webpack_public_path__ + "static/media/carousel6.f7c58091.png";